import cx from 'classnames';
import React from 'react';
import styles from '../card.module.scss';
export const CardFooter = ({ children, showDivider = false, className, }) => {
    const dividerClass = cx({ [styles.divider]: showDivider });
    return (React.createElement(React.Fragment, null,
        showDivider && React.createElement("div", { className: dividerClass }),
        React.createElement("div", { className: cx(styles.cardSectionWrapper, className) }, children)));
};
//# sourceMappingURL=card-footer.js.map